'use client';

import { useTranslations } from 'next-intl';
import React from 'react';
import Link from '@/components/common/link';
import LicenceItems from '@/components/layout/footer/footer-licence/licence-items';

const FooterLicence = () => {
  const t = useTranslations('footer.license');

  const licenseRenderer = () => {
    if (!t('license-label')) {
      return null;
    }

    return (
      <a
        target="_blank"
        href="https://anjouangaming.com/license-register/#:~:text=vatanplatform.com-,vatan.game"
        className="!vt-colors-statuses-info-weak !vt-text-size-medium"
      >
        {t('license-label')}
      </a>
    );
  };

  const termsAndConditionsLinkRenderer = () => (
    <Link
      href="/static/terms-and-conditions"
      className="!vt-colors-statuses-info-weak !vt-text-size-medium"
    >
      {t('terms-and-conditions-label')}
    </Link>
  );

  const emailRenderer = () => (
    <a
      href={`mailto:${t('e-mail')}`}
      className="vt-colors-statuses-info-weak hover:underline"
    >
      {t('e-mail')}
    </a>
  );

  return (
    <div className="flex w-full flex-col justify-between">
      <div className="line pt-10 leading-[18px] vt-atoms-link-text">
        <p>
          {t.rich('info-1', {
            license: licenseRenderer,
            termsAndConditions: termsAndConditionsLinkRenderer,
          })}
        </p>
        <p>
          {t.rich('info-2', {
            email: emailRenderer,
          })}
        </p>
      </div>
      <LicenceItems />
    </div>
  );
};

export default FooterLicence;
